<template>
  <nav
    class="relative flex w-full flex-nowrap items-center justify-between bg-primary-600 py-4 shadow-dark-mild lg:flex-wrap lg:justify-start lg:py-4 sm:px-40"
    data-twe-navbar-ref
  >
    <div class="flex w-full flex-wrap items-center justify-between px-3">
      <div class="mx-2">
        <a class="text-xl text-neutral-100 philosopher-bold" href="#">Al-Azhar Islamic Science for Foreigner</a>
      </div>
      <!-- Hamburger button for mobile view -->
      <button
        class="block border-0 bg-transparent px-2 text-neutral-300 hover:no-underline hover:shadow-none focus:no-underline focus:shadow-none focus:outline-none focus:ring-0 dark:text-neutral-200 lg:hidden"
        type="button"
        @click="openHamburger = !openHamburger"
        data-twe-collapse-init
        data-twe-target="#navbarSupportedContent9"
        aria-controls="navbarSupportedContent9"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <!-- Hamburger icon -->
        <span
          class="[&>svg]:w-7 [&>svg]:stroke-black/50 dark:[&>svg]:stroke-neutral-200"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
      </button>

      <!-- Collapsible navbar container -->
      <div
        :class="openHamburger ? 'flex' : 'hidden'"
        class="!visible mt-2 flex-grow basis-[100%] items-center lg:mt-0 lg:!flex lg:basis-auto justify-items-end content-end items-end"
        id="navbarSupportedContent9"
        data-twe-collapse-item
      >
        <!-- Left links -->
        <ul
          class="list-style-none mx-auto md:ms-auto md:ml-auto md:mr-0 flex flex-col ps-0 lg:mt-1 lg:flex-row justify-end content-end"
          data-twe-navbar-nav-ref
        >
          <!-- Home link -->
          <li
            class="my-4 ps-2 lg:my-0 lg:pe-1 lg:ps-2 text-center"
            data-twe-nav-item-ref
          >
            <router-link
              aria-current="page"
              href="#"
              data-twe-nav-link-ref
              class="text-white transition duration-200 hover:text-neutral-200 hover:ease-in-out focus:text-neutral-200 active:text-white motion-reduce:transition-none lg:px-2"
              to="/"
              >Beranda</router-link
            >
          </li>
          <!-- Features link -->
          <li
            class="mb-4 ps-2 lg:mb-0 lg:pe-1 lg:ps-0 text-center"
            data-twe-nav-item-ref
          >
            <router-link
              to="/registrasi"
              class="p-0 text-white transition duration-200 hover:text-neutral-200 hover:ease-in-out focus:text-neutral-200 active:text-white motion-reduce:transition-none lg:px-2"
              href="#"
              data-twe-nav-link-ref
              >Pendaftaran</router-link
            >
          </li>
          <!-- Pricing link -->
          <li class="mb-4 ps-2 lg:mb-0 lg:pe-1 lg:ps-0" data-twe-nav-item-ref>
            <router-link
              to="/check-status"
              class="p-0 text-white transition duration-200 bg-orange-600 py-3 px-5 rounded-xl hover:bg-orange-500 hover:text-white hover:ease-in-out focus:text-white motion-reduce:transition-none"
              href="#"
              data-twe-nav-link-ref
              >Cek Status Pendaftaran</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from "vue";

const openHamburger = ref(false);
</script>

<style>
nav.main-header {
  display: flex;
  gap: 20px;
  justify-content: center;
  padding: 30px;
  border-bottom: 1px solid #e4e4e4;
}

.philosopher-bold {
  font-family: "Philosopher", sans-serif;
  font-weight: 700;
  font-style: normal;
}
</style>
